import { render, staticRenderFns } from "./MedicalHistory.vue?vue&type=template&id=7df9c20a&scoped=true"
import script from "./MedicalHistory.vue?vue&type=script&lang=js"
export * from "./MedicalHistory.vue?vue&type=script&lang=js"
import style0 from "./MedicalHistory.vue?vue&type=style&index=0&id=7df9c20a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df9c20a",
  null
  
)

export default component.exports